import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Check if all fields are filled
  const isDisabled =
    !formData.name.trim() ||
    !formData.email.trim() ||
    !formData.message.trim();

  const sendWhatsApp = (e) => {
    e.preventDefault();

    const { name, email, message } = formData;
    const phoneNumber = "917631608743"; // WhatsApp number with country code

    const whatsappMessage = `Hello, I am ${name}.
Email: ${email}
Message: ${message}`;

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappURL, "_blank");

    toast.success("Message sent to WhatsApp!");

    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="relative min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4">

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/917631608743"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all animate-bounce"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          fill="white"
          className="w-7 h-7"
        >
          <path d="M380.9 97.1C339-... truncated for brevity" />
        </svg>
      </a>

      <div className="bg-white w-full max-w-2xl shadow-lg rounded-xl p-8">

        <h2 className="text-3xl font-bold text-center text-blue-700 mb-4">
          For Query or Suggestion
        </h2>

        <p className="text-center text-gray-600 mb-8">
          Feel free to contact us anytime. We will respond as soon as possible.
        </p>

        {/* Contact Form */}
        <form onSubmit={sendWhatsApp} className="space-y-5">

          {/* Name */}
          <div>
            <label className="block text-gray-700 mb-1">Your Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              placeholder="Enter your name"
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 mb-1">Your Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              placeholder="Enter your email"
              required
            />
          </div>

          {/* Message */}
          <div>
            <label className="block text-gray-700 mb-1">Your Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
              placeholder="Write your query or suggestion..."
              required
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              disabled={isDisabled}
              className={`px-6 py-2 rounded-lg text-white transition-all ${
                isDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700"
              }`}
            >
              Send on WhatsApp
            </button>
          </div>
        </form>
      </div>

      {/* Toast */}
      <ToastContainer />
    </div>
  );
};

export default Contact;
